export default {
  socket: {
    channel: null,
    isConnected: false,
    scoketId: null,
    lastSentData: null,
    lastHandledData: null,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/socket/state.js